import ArrowRightIcon from './Icons/ArrowRightIcon';
import PortalPickerSubmenu from './PortalPickerSubmenu';
import { memo } from 'react';
import { useIsHubless, usePortal, useTranslation } from '../../hooks/useNavConfig';
import { MenuPicker, MenuItem, MenuPickerTitle, MenuPickerBody } from '../Menu';
import styled, { css } from 'foundations-theming/utils';
import { getAccountMenuBorder, getAccountMenuItemPadding } from './shared-styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledMenuItem = styled(MenuItem)(({
  theme
}) => css(["list-style-type:none !important;border-bottom:", " !important;padding:", " !important;pointer-events:none;"], getAccountMenuBorder(theme), getAccountMenuItemPadding(theme)));
const PortalPicker = ({
  accountName,
  accounts
}) => {
  const {
    portalId
  } = usePortal();
  const {
    t
  } = useTranslation();
  const isHubless = useIsHubless();
  const ariaLabel = t('nav.tools.portalPickerAriaLabel', {
    accountName,
    portalId: portalId.toString()
  });
  const accountLabel = t('nav.tools.devAccount');
  const accountNameToDisplay = isHubless ? t('nav.tools.accounts') : accountName;
  const portalPickerBody = /*#__PURE__*/_jsx(MenuPickerBody, {
    name: accountNameToDisplay,
    portalId: portalId
  });
  if (accounts.length === 0) {
    return /*#__PURE__*/_jsxs(StyledMenuItem, {
      id: "navAccount-current",
      "data-test-id": "nav-account-menu-portal-picker-single",
      "aria-label": ariaLabel,
      children: [/*#__PURE__*/_jsx(MenuPickerTitle, {
        title: 'Account'
      }), portalPickerBody]
    });
  }
  return /*#__PURE__*/_jsxs(MenuPicker, {
    id: "navAccount-current",
    title: isHubless ? undefined : accountLabel,
    "aria-owns": "navAccountSwitcher",
    "aria-controls": "navAccountSwitcher",
    "data-test-id": "nav-account-menu-portal-picker",
    "aria-label": ariaLabel,
    submenu: /*#__PURE__*/_jsx(PortalPickerSubmenu, {
      accounts: accounts
    }),
    children: [portalPickerBody, /*#__PURE__*/_jsx(ArrowRightIcon, {})]
  });
};
export default /*#__PURE__*/memo(PortalPicker);